/**
 * Booking-time policy constants. These mirror prospin-api's
 * CLUB_SLOT_STEP_MINUTES env var. The club is permanently 24/7 so there are
 * no open/close env vars. If the API changes slot step, update this file too
 * — there is no client-side fetch for policy yet.
 */
export const POLICY = {
  OPEN_HOUR: 0,
  CLOSE_HOUR: 24, // exclusive; last slot starts at 23:45
  SLOT_STEP_MINUTES: 15,
} as const;

/** seconds — for <input type="time" step={...} /> */
export const SLOT_STEP_SECONDS = POLICY.SLOT_STEP_MINUTES * 60;

/** "HH:MM" — pass to <input type="time" min={...} /> */
export const POLICY_MIN_TIME = "00:00";

/**
 * Last legal start time (00:00 + N×step that's still < CLOSE_HOUR).
 * Note: HTML <input type="time"> cannot represent "24:00", so end-time
 * inputs intentionally omit max — the backend validates.
 */
export const POLICY_MAX_START_TIME = "23:45";
